import axios from 'axios';

const host =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_LOCAL_API_HOST || 'localhost:44301'
    : process.env.NEXT_PUBLIC_HOST;

axios.defaults.baseURL = `https://${host}/api`;

const getLanguage = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('selected-lang') || 'en'; // Default to 'en' if not found
  } else {
    return 'en';
  }
};

axios.interceptors.request.use(
  (config) => {
    const language = getLanguage(); // Replace with your logic to get the current language
    if (language) {
      config.headers['Accept-Language'] = language.toLowerCase() === 'cz' ? 'cs' : language;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
